import React, {FC} from 'react';

import {EFormMode} from 'components/form/form-types';
import {
    ECustomFormEntityName,
    CustomFormModal,
    customFormsMapping,
} from 'pages/table-page/query-params-aware-table/custom-form-modal';
import {useAppSelector} from 'store/config/hooks';
import {controlRatioSelectors} from 'store/slices/control-ratio-slice';
import {TModalComponentInterface, selectModalData} from 'store/slices/modals-slice';

import {FormContainer} from '../form-container/form-container';
import {FormModalWrapper} from './form-modal-wrapper';
import {getApiUrlForFormModal} from './lib';

import './form-modal.less';

interface IFormModalProps extends TModalComponentInterface {
    entityName: string;
}

export const FormModal: FC<IFormModalProps> = ({
    onClose,
    entityName,
}: IFormModalProps) => {
    const controlRatioParameters = useAppSelector(controlRatioSelectors.selectFormAdditionalParameters);
    const generalModalParams = useAppSelector(state => selectModalData(state)?.modalParameters);

    if (customFormsMapping[entityName as ECustomFormEntityName]) {
        return (
            <CustomFormModal
                mode={EFormMode.CREATE}
                entityName={entityName as ECustomFormEntityName}
                handleClose={onClose}
            />
        );
    }

    return (
        <FormModalWrapper
            entityName={entityName}
            onClose={onClose}
        >
            {handleClose => (
                <FormContainer
                    entityName={entityName}
                    onClose={handleClose}
                    additionalValuesForRequest={{
                        ...(generalModalParams?.id != null ? {id: generalModalParams.id} : {}),
                        ...controlRatioParameters,
                    }}
                    url={getApiUrlForFormModal(entityName)}
                />
            )}
        </FormModalWrapper>
    );
};
